export const closeWebview = () => {
  const $lucifer = new Lucifer.default();
  $lucifer.closePage();
};
